import React from 'react';
import BottomSheet from '@/app/components/bottom_sheet/widget';
import { ThirtyText, TextBold16 } from '@/app/components/texts';
import Button from '@/app/components/button';
import LazyAssets from '@/app/utils/assets_widget';
import { t } from 'i18next';
import { s } from '@/app/utils/s';
import styles from '../styles.module.scss';

interface LogoutDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
}

/**
 * Dialog for confirming logout action
 */
const LogoutDialog: React.FC<LogoutDialogProps> = ({
  isOpen,
  onClose,
  onLogout,
}) => {
  return (
    <BottomSheet open={isOpen} onClose={onClose}>
      <div className={styles.wantToLeaveDialog}>
        <ThirtyText text={t(s.wantToLeave)} />
        <TextBold16 text={t(s.weWillBeWaiting)} />
        <div className={styles.buttons}>
          <Button text={t(s.notNow)} onClick={onClose} isOutline />
          <Button 
            text={t(s.logOut)} 
            onClick={onLogout} 
            icon={<LazyAssets.LogOut />} 
            isRed 
          />
        </div>
      </div>
    </BottomSheet>
  );
};

export default LogoutDialog;